import type { ProductCatalog } from "@sharpana/payments/types";

/**
 * The coaching product's store SKUs, as the zairai mobile app sells them.
 *
 * These ids are the contract with App Store Connect and the Play Console: a
 * product only appears in the paywall if an id here matches one RevenueCat
 * returns for the signed-in store.  Nothing resolves until the zairai apps
 * exist and these exact ids are created in BOTH stores and added to the
 * zairai RevenueCat project — until then the paywall renders without prices,
 * which is the honest failure and not a crash.
 *
 * `pricingIds` is separate from `purchaseIds` because Play reports a
 * subscription's price under `<subscriptionId>:<basePlanId>` while the
 * purchase is made against the bare subscription id.  boilit's catalog has
 * the same split for the same reason.
 */
export const zairaiProducts: ProductCatalog = {
  creditPack: {
    purchaseIds: {
      ios: "zairai_credit_pack_v1",
      android: "zairai_credit_pack_v1",
    },
    pricingIds: {
      ios: "zairai_credit_pack_v1",
      android: "zairai_credit_pack_v1",
    },
    productType: "non_subscription",
    // Must match a SkuCatalog row seeded by core/payments_logic/seed_skus.py.
    productLogicalNameId: "token_pack_30",
  },
  subscription: {
    purchaseIds: {
      ios: "zairai_monthly_v1",
      android: "zairai_subscription_v1",
    },
    pricingIds: {
      ios: "zairai_monthly_v1",
      android: "zairai_subscription_v1:zairai-subscription-v1",
    },
    productType: "subscription",
    productLogicalNameId: "subscription_plus",
  },
};
